import api from '../api';

export const getLineRestrictions = async () => {
	const response = await api.get(
		'/authentication-and-authorization/line-restrictions'
	);
	return response.data;
};
